/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BillingMethod } from './BillingMethod';
import {
    BillingMethodFromJSON,
    BillingMethodFromJSONTyped,
    BillingMethodToJSON,
} from './BillingMethod';
import type { BillingPeriodSchema } from './BillingPeriodSchema';
import {
    BillingPeriodSchemaFromJSON,
    BillingPeriodSchemaFromJSONTyped,
    BillingPeriodSchemaToJSON,
} from './BillingPeriodSchema';
import type { FeatureTier } from './FeatureTier';
import {
    FeatureTierFromJSON,
    FeatureTierFromJSONTyped,
    FeatureTierToJSON,
} from './FeatureTier';
import type { SubscriptionStatus } from './SubscriptionStatus';
import {
    SubscriptionStatusFromJSON,
    SubscriptionStatusFromJSONTyped,
    SubscriptionStatusToJSON,
} from './SubscriptionStatus';

/**
 * This schema exists for backward compatibility and is just a weird view of an Organization
 * 
 * We currently use this for the get-program endpoint, which can used for historical views of an organiztion,
 * so it might stick around for a bit.
 * @export
 * @interface ProgramSchema
 */
export interface ProgramSchema {
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    coreLimitMembers: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    memberLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    nodeLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    seatLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    workspaceLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    spotUsageLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    armUsageLimit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramSchema
     */
    canUsePrivatePypi?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramSchema
     */
    canUseCustomNetworking?: boolean;
    /**
     * 
     * @type {FeatureTier}
     * @memberof ProgramSchema
     */
    tier: FeatureTier;
    /**
     * 
     * @type {BillingMethod}
     * @memberof ProgramSchema
     */
    billingMethod: BillingMethod;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    coiledCreditValue: number;
    /**
     * 
     * @type {Date}
     * @memberof ProgramSchema
     */
    renewDate: Date;
    /**
     * 
     * @type {Array<BillingPeriodSchema>}
     * @memberof ProgramSchema
     */
    billingPeriods?: Array<BillingPeriodSchema>;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof ProgramSchema
     */
    subscriptionStatus?: SubscriptionStatus;
    /**
     * 
     * @type {Date}
     * @memberof ProgramSchema
     */
    trialExpiration?: Date;
    /**
     * 
     * @type {FeatureTier}
     * @memberof ProgramSchema
     */
    nextPhaseTier?: FeatureTier;
    /**
     * 
     * @type {Date}
     * @memberof ProgramSchema
     */
    cancelAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    creditAllotment: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProgramSchema
     */
    spendLimitShouldStopInstances: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    programDollarsSpendLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ProgramSchema
     */
    organizationCreditLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgramSchema
     */
    organizationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramSchema
     */
    accountName?: string;
}

/**
 * Check if a given object implements the ProgramSchema interface.
 */
export function instanceOfProgramSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "coreLimitMembers" in value;
    isInstance = isInstance && "memberLimit" in value;
    isInstance = isInstance && "nodeLimit" in value;
    isInstance = isInstance && "tier" in value;
    isInstance = isInstance && "billingMethod" in value;
    isInstance = isInstance && "coiledCreditValue" in value;
    isInstance = isInstance && "renewDate" in value;
    isInstance = isInstance && "creditAllotment" in value;
    isInstance = isInstance && "spendLimitShouldStopInstances" in value;
    isInstance = isInstance && "programDollarsSpendLimit" in value;

    return isInstance;
}

export function ProgramSchemaFromJSON(json: any): ProgramSchema {
    return ProgramSchemaFromJSONTyped(json, false);
}

export function ProgramSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'coreLimitMembers': json['core_limit_members'],
        'memberLimit': json['member_limit'],
        'nodeLimit': json['node_limit'],
        'seatLimit': !exists(json, 'seat_limit') ? undefined : json['seat_limit'],
        'workspaceLimit': !exists(json, 'workspace_limit') ? undefined : json['workspace_limit'],
        'spotUsageLimit': !exists(json, 'spot_usage_limit') ? undefined : json['spot_usage_limit'],
        'armUsageLimit': !exists(json, 'arm_usage_limit') ? undefined : json['arm_usage_limit'],
        'canUsePrivatePypi': !exists(json, 'can_use_private_pypi') ? undefined : json['can_use_private_pypi'],
        'canUseCustomNetworking': !exists(json, 'can_use_custom_networking') ? undefined : json['can_use_custom_networking'],
        'tier': FeatureTierFromJSON(json['tier']),
        'billingMethod': BillingMethodFromJSON(json['billing_method']),
        'coiledCreditValue': json['coiled_credit_value'],
        'renewDate': (new Date(json['renew_date'])),
        'billingPeriods': !exists(json, 'billing_periods') ? undefined : ((json['billing_periods'] as Array<any>).map(BillingPeriodSchemaFromJSON)),
        'subscriptionStatus': !exists(json, 'subscription_status') ? undefined : SubscriptionStatusFromJSON(json['subscription_status']),
        'trialExpiration': !exists(json, 'trial_expiration') ? undefined : (new Date(json['trial_expiration'])),
        'nextPhaseTier': !exists(json, 'next_phase_tier') ? undefined : FeatureTierFromJSON(json['next_phase_tier']),
        'cancelAt': !exists(json, 'cancel_at') ? undefined : (new Date(json['cancel_at'])),
        'creditAllotment': json['credit_allotment'],
        'spendLimitShouldStopInstances': json['spend_limit_should_stop_instances'],
        'programDollarsSpendLimit': json['program_dollars_spend_limit'],
        'organizationCreditLimit': !exists(json, 'organization_credit_limit') ? undefined : json['organization_credit_limit'],
        'organizationName': !exists(json, 'organization_name') ? undefined : json['organization_name'],
        'accountName': !exists(json, 'account_name') ? undefined : json['account_name'],
    };
}

export function ProgramSchemaToJSON(value?: ProgramSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'core_limit_members': value.coreLimitMembers,
        'member_limit': value.memberLimit,
        'node_limit': value.nodeLimit,
        'seat_limit': value.seatLimit,
        'workspace_limit': value.workspaceLimit,
        'spot_usage_limit': value.spotUsageLimit,
        'arm_usage_limit': value.armUsageLimit,
        'can_use_private_pypi': value.canUsePrivatePypi,
        'can_use_custom_networking': value.canUseCustomNetworking,
        'tier': FeatureTierToJSON(value.tier),
        'billing_method': BillingMethodToJSON(value.billingMethod),
        'coiled_credit_value': value.coiledCreditValue,
        'renew_date': (value.renewDate.toISOString()),
        'billing_periods': value.billingPeriods === undefined ? undefined : ((value.billingPeriods as Array<any>).map(BillingPeriodSchemaToJSON)),
        'subscription_status': SubscriptionStatusToJSON(value.subscriptionStatus),
        'trial_expiration': value.trialExpiration === undefined ? undefined : (value.trialExpiration.toISOString()),
        'next_phase_tier': FeatureTierToJSON(value.nextPhaseTier),
        'cancel_at': value.cancelAt === undefined ? undefined : (value.cancelAt.toISOString()),
        'credit_allotment': value.creditAllotment,
        'spend_limit_should_stop_instances': value.spendLimitShouldStopInstances,
        'program_dollars_spend_limit': value.programDollarsSpendLimit,
        'organization_credit_limit': value.organizationCreditLimit,
        'organization_name': value.organizationName,
        'account_name': value.accountName,
    };
}

